import { GenericCombobox } from '@/common'
import useUnlocodes from '@/common/hooks/useUnlocodes'

type AutocompleteOption = {
  label: string
  value: string
  id: string
}

const UnlocodeInput = ({
  countryCodeFilter,
  onChange,
  label,
  tooltip,
  tooltipPlacement,
  tooltipSize,
  value
}: {
  label: string | null
  tooltip?: string
  tooltipPlacement?: 'top' | 'bottom'
  tooltipSize?: 'small' | 'medium' | 'large'
  countryCodeFilter: string | null
  onChange: (value: string | null) => void
  value: string | null
}) => {
  const { data: items } = useUnlocodes(countryCodeFilter)
  const baseOptions =
    items?.map(([code, name]: [string, string]) => ({
      label: `${code} (${name})`,
      value: code,
      id: code
    })) ?? []

  const options =
    value && !baseOptions.some(option => option.value === value)
      ? [{ value, label: `${value} (current)`, id: value }, ...baseOptions]
      : baseOptions

  const selectedOption = options.find(option => option.value === value) ?? null
  return (
    <GenericCombobox<AutocompleteOption>
      label={label || ''}
      items={options}
      tooltip={tooltip}
      tooltipPlacement={tooltipPlacement}
      tooltipSize={tooltipSize}
      clearable
      onChange={selected => {
        onChange(selected?.value ?? null)
      }}
      value={selectedOption}
    />
  )
}

export default UnlocodeInput
